<script setup>
import { useI18n } from 'vue-i18n';
import Modal from 'dashboard/components/Modal.vue';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  agentName: { type: String, default: '' },
  onClose: { type: Function, default: () => {} },
  onConfirm: { type: Function, default: () => {} },
});

const show = defineModel('show', { type: Boolean, default: false });

const { t } = useI18n();
</script>

<template>
  <Modal v-model:show="show" :on-close="onClose">
    <woot-modal-header
      :header-title="t('AGENT_MGMT.ACTIVATION.CONFIRM.TITLE', { agentName })"
    >
      <div class="flex flex-col gap-1 w-full mt-2">
        <p class="text-sm leading-5 text-n-slate-11">
          {{ t('AGENT_MGMT.ACTIVATION.CONFIRM.SYSTEM_ACCESS_MESSAGE') }}
        </p>
        <p class="text-sm leading-5 text-n-slate-11">
          {{ t('AGENT_MGMT.ACTIVATION.CONFIRM.MESSAGES_RETAINED_MESSAGE') }}
        </p>
      </div>
    </woot-modal-header>
    <div class="flex items-center justify-end gap-2 p-8">
      <Button
        faded
        slate
        type="reset"
        :label="t('AGENT_MGMT.ACTIVATION.CONFIRM.CANCEL_BUTTON_TEXT')"
        @click="onClose"
      />
      <Button
        ruby
        type="submit"
        :label="t('AGENT_MGMT.ACTIVATION.CONFIRM.CONFIRM_BUTTON_TEXT')"
        @click="onConfirm"
      />
    </div>
  </Modal>
</template>
